/**
 * @generated SignedSource<<7f256333aa91333cdc71372479c9bb4b>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Query } from 'relay-runtime';
type Jobs_organization$fragmentType = any;
export type IndexJobIndexQuery$variables = {|
  organizationSlug: string,
|};
export type IndexJobIndexQuery$data = {|
  +organization: ?{|
    +name: string,
    +slug: string,
    +$fragmentSpreads: Jobs_organization$fragmentType,
  |},
|};
export type IndexJobIndexQuery = {|
  response: IndexJobIndexQuery$data,
  variables: IndexJobIndexQuery$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organizationSlug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "organizationSlug"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IndexJobIndexQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "Jobs_organization"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IndexJobIndexQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "organization",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d56d37e7f72b7a8540251283481afecd",
    "id": null,
    "metadata": {},
    "name": "IndexJobIndexQuery",
    "operationKind": "query",
    "text": "query IndexJobIndexQuery(\n  $organizationSlug: ID!\n) {\n  organization(slug: $organizationSlug) {\n    name\n    slug\n    ...Jobs_organization\n    id\n  }\n}\n\nfragment Jobs_organization on Organization {\n  name\n  slug\n}\n"
  }
};
})();

(node/*: any*/).hash = "ae879579da546278457258b3b2ed32ab";

module.exports = ((node/*: any*/)/*: Query<
  IndexJobIndexQuery$variables,
  IndexJobIndexQuery$data,
>*/);
